import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Column, Padding, Button } from '../../../../..'
import { ValueGroup, Label, Value, EditIcon, MediaButtons } from '../MediaItem.style'
import MediaUpdateModal from '../../../../../../containers/Content/Media/MediaUpdateModal'
import { FileUtils } from '../../../../../../utils'
import { useSize } from '../../../../../utils'
import { useSelector } from 'react-redux'

const RightColumn = ({ inSelectedPlaylist, isBeingUploaded, isDownloadBlocked, media, onEdit, onRemoveMedia, onDownloadMedia }) => {
    const { t } = useTranslation()
    const { isMobile } = useSize()
    const { date_end: dateEnd, date_start: dateStart, id, render_tool_id: renderToolID, schedules, order } = media

    const state = useSelector((state) => state)
    const object = state.content.media.find((obj) => obj.id === id)
    /**
     * On Download Button click
     * @param {Object} e
     */
    const onDownloadClick = (e) => {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        if (isDownloadBlocked) {
            return
        }

        if (onDownloadMedia) {
            onDownloadMedia(id, false)
        }
    }

    /**
     * On remove media button click
     * @param {Object} e
     */
    const onRemoveClick = (e) => {
        const queryString = window.location.href
        if (!queryString.match(/(^.+\/content\/media$)/g)) {
            if (window.confirm('Are you sure you wish to remove this media from playlist?')) {
                if (onRemoveMedia(id, order)) {
                    alert('Media deleted')
                    e.stopPropagation()
                    return
                } else {
                    return
                }
            } else {
                return
            }
        }

        if (object.playlists.length > 0 && queryString.match(/(^.+\/content\/media$)/g)) {
            alert('Unable to delete, currently in active playlist')
            e.stopPropagation()
            return
        }

        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }
        onRemoveMedia(id)
    }

    /**
     * On approve click
     * @param {Object} e
     */
    const onEditClick = (e) => {
        e.stopPropagation()
        onEdit(id)
    }

    const formatDate = (date) => (date ? moment(date).fromNow() : 'N/A')

    const datesLabel = `${formatDate(dateStart)} - ${formatDate(dateEnd)}`

    return (
        <Column position="initial" width={isMobile ? '35%' : '45%'}>
            <Padding top fullHeight size="ssm">
                <MediaUpdateModal inSelectedPlaylist={inSelectedPlaylist} media={media}>
                    {!isMobile && (
                        <>
                            <ValueGroup nomargin>
                                {!isBeingUploaded && (
                                    <>
                                        <Label>{`${t('file-size')}:`}</Label>
                                        <Value>{FileUtils.humanFileSize(media.file_size)}</Value>
                                    </>
                                )}
                            </ValueGroup>
                            <ValueGroup>
                                {!isBeingUploaded && (
                                    <>
                                        <Label>{`${t('resolution')}:`}</Label>
                                        <Value>{`${media.width} x ${media.height}`}</Value>
                                    </>
                                )}
                            </ValueGroup>
                            <ValueGroup withAction nomargin>
                                <Label>{`${t('scheduled')}:`}</Label>
                                <Value>
                                    {datesLabel}
                                    {schedules && !!schedules.length && (
                                        <>
                                            &nbsp;
                                            <FontAwesomeIcon icon="clock" />
                                        </>
                                    )}
                                </Value>
                            </ValueGroup>
                        </>
                    )}
                </MediaUpdateModal>
            </Padding>
            <MediaButtons>
                {renderToolID && (
                    <Button theme="secondary" size="xxs" radius="5" onClick={onEditClick}>
                        <EditIcon />
                    </Button>
                )}
                {!isBeingUploaded && (
                    <Button theme="secondary" size="xxs" radius="5" onClick={onDownloadClick} disabled={isDownloadBlocked}>
                        <FontAwesomeIcon icon="download" size="1x" />
                    </Button>
                )}
                <Button theme="secondaryDanger" size="xxs" radius="5" onClick={onRemoveClick}>
                    <FontAwesomeIcon icon="trash-alt" size="1x" />
                </Button>
            </MediaButtons>
        </Column>
    )
}

RightColumn.propTypes = {
    inSelectedPlaylist: PropTypes.bool,
    isBeingUploaded: PropTypes.bool,
    isDownloadBlocked: PropTypes.bool,
    media: PropTypes.shape({
        id: PropTypes.number,
        render_tool_id: PropTypes.string,
    }),
    onEdit: PropTypes.func.isRequired,
    onRemoveMedia: PropTypes.func.isRequired,
    onDownloadMedia: PropTypes.func.isRequired,
}

RightColumn.defaultProps = {
    inSelectedPlaylist: false,
    isBeingUploaded: false,
    isDownloadBlocked: false,
    media: {},
}

export default RightColumn
